import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { Link } from "react-router-dom";
import './AdminBlogsList.css'
export default function AdminBlogsList() {
  const [blogs, setBlogs] = useState([]);

  const fetchBlogs = async () => {
    const snapshot = await getDocs(collection(db, "blogs"));

    const data = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setBlogs(data);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Delete this blog?");
    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "blogs", id));

      // update UI
      setBlogs(prev => prev.filter(blog => blog.id !== id));

    } catch (error) {
      console.error(error);
      alert("Error deleting ❌");
    }
  };

  return (
    <div className="admin-blog">
      <div className="admin-container">
        <h1>Manage Blogs</h1>

        {blogs.map(blog => (
          <div key={blog.id} className="admin-blog-card">
            <h3>{blog.title}</h3>

            <div className="admin-actions">
              <Link to={`/blog/${blog.slug}`}>View</Link>

              <button onClick={() => handleDelete(blog.id)}>
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}